var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"echarts",staticStyle:{"margin":"0 auto"},style:({ width: '100%', height: '6rem' })})])}
var staticRenderFns = []

export { render, staticRenderFns }